/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ISurveyHeaders } from 'app/shared/model/survey-headers.model';

export interface ISurveySections {
  id?: string;
  sectionName?: string | null;
  sectionTitle?: string | null;
  sectionSubheading?: string | null;
  sectionRequired?: boolean;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  surveyHeader?: ISurveyHeaders | null;
}

export const defaultValue: Readonly<ISurveySections> = {
  sectionRequired: false,
  active: false,
};
